import { useContext } from 'react';
import { MortalityMobidityChartsDataContext } from '../contexts/MortalityMobidityChartsDataContext';

export const useMortalityMobidityChartsDataContext = () => {
    return useContext(MortalityMobidityChartsDataContext);
};
